// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"695":"2973f6bd","777":"14766296","932":"949941ba"}[chunkId] + ".chunk.css";
};